import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { GetListOfUserSubscriptions, PaginatedUserSubscriptions } from "../../../models/dashboard/subscriptions/subscriptions";

const getListOfUserSubscriptions = (model:GetListOfUserSubscriptions): Promise<PaginatedUserSubscriptions> => {
    return adminHttpClient.get(`/api/Admin/AdminSubscriptions/get-users-subscriptions?PageNumber=${model.pageNumber}&PageSize=${model.pageSize}&SearchValue=${model.searchValue}&SortColumn=${model.sortColumn}&OrderDescending=${model.orderDescending}`)
}

export default getListOfUserSubscriptions;